import http from "@/utils/http";

export const updateForLive = (data) => {
  return http.request({
    url: "/cdapi/commonfissionrecord/updateForLive",
    method: "POST",
    data: { ...data, ascriptionModular: "10" },
  });
};

export const commonactivityList = (params) => {
  return http.request({
    url: "/cdapi/commonactivity/list",
    method: "POST",
    params,
  });
};

//慕思经典818大屏数据
//获取奖品列表
export const lotteryPrizeList = (params) => {
  return http.request({
    url: "/consumer-admin//eoe/lottery/lotteryPrize/list",
    method: "get",
    params,
    withLoading: false,
  });
};

//参与抽奖人数的计数接口
export const lotteryUserGetCurrentUserCount = (params) => {
  return http.request({
    url: "/consumer-admin/eoe/lottery/lotteryUser/getCurrentUserCount",
    method: "get",
    params,
    withLoading: false,
  });
};

//获取中奖名单
export const lotteryWinnerList = (params) => {
  return http.request({
    url: "/consumer-admin/eoe/lottery/lotteryWinner/list",
    method: "post",
    params,
    withLoading: false,
  });
};
